module.exports = __webpack_public_path__ + "static/media/title_shisan.16b60429.svg";